import React, {useState} from "react"

import {Card, CardBody, Container, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTitle from "../../components/MetaTitle"
import classnames from "classnames"
import BusinessesTable from "../../components/Tables/BusinessesTable"

const styles = {
    tabStyle: {
        cursor: "pointer"
    }
}

const Businesses = props => {
    const [activeTab, setActiveTab] = useState(0)
    const toggle = tab => setActiveTab(tab)

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTitle title="Companies"/>
                <Container fluid={true}>
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Businesses" {...props}/>
                    <Card>
                        <CardBody>

                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        style={styles.tabStyle}
                                        className={classnames({
                                            active: activeTab === 0,
                                        })}
                                        onClick={() => toggle(0)}
                                    >
                                        Pending Approval
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={styles.tabStyle}
                                        className={classnames({
                                            active: activeTab === 1,
                                        })}
                                        onClick={() => toggle(1)}
                                    >
                                        Approved
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            <TabContent activeTab={activeTab} className="p-3 text-muted">
                                <TabPane tabId={0}>
                                    <BusinessesTable active={0}/>
                                </TabPane>
                                <TabPane tabId={1}>
                                    <BusinessesTable active={1}/>
                                </TabPane>

                            </TabContent>

                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Businesses
